import { userGetNotifications } from '@/modules/user/userActions';
import type { User } from '@/modules/user/userTypes';
import type { RootState } from '@/rootReducer';
import { useCallback, useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

type UseNotificationQueryProps = {
	user: User;
};

export const useNotificationQuery = ({ user }: UseNotificationQueryProps) => {
	const dispatch = useDispatch();

	const [userNotifications] = useSelector(
		(state: RootState) => [
			state.user.getIn(['authorize', 'user', 'notifications'])
		],

		shallowEqual
	);

	const [editableUser] = useSelector(
		(state: RootState) => [state.user.getIn(['editableUser', 'data'])],

		shallowEqual
	);

	const getNotifications = useCallback(
		() => dispatch(userGetNotifications()),
		[dispatch]
	);

	useEffect(() => {
		if (user?.email && !editableUser && !user?.facebookFreemium) {
			getNotifications();
		}
	}, [editableUser, getNotifications, user?.email, user?.facebookFreemium]);

	return { userNotifications };
};
